import React from "react";
import Grid from "@material-ui/core/Grid";

const NewReportTile = ({ routeToNew }) => {
  return (
    <Grid
      item
      onClick={routeToNew}
      className="main-survey-tile main-survey-new"
    >
      <div className="inline-center">
        <p
          style={{
            fontSize: 26,
            fontWeight: 700,
            marginBottom: -5,
            marginTop: -10,
          }}
        >
          +
        </p>
        <h3 style={{ fontSize: 22 }}>New Report</h3>
      </div>
    </Grid>
  );
};

export default NewReportTile;
